var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4",attrs:{"id":"section-to-print"}},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_vm._v("\n    Loading...\n  ")]):_c('div',_vm._l((_vm.qrs),function(qr){return _c('div',{key:qr.code},[_c('ticket-print',{staticClass:"mb-4",attrs:{"item":qr}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }